var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('default-chart',{attrs:{"widgetData":_vm.widgetData,"chartType":"bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }